/**
 * Prevents Angular change detection from
 * running with certain Web Component callbacks.
 */

(window as any).__Zone_disable_customElements = true;

/**
 * Prevents angular change detection from
 * running with certain file reader events.
 *
 * In this case, we are disabling FileReader events because in safari iphone X, it was
 * causing the FileReader events to be blocked.
 * This problem was reported in the following issue:
 * - https://github.com/danielsogl/awesome-cordova-plugins/issues/505.
 */
(window as any).__Zone_disable_FileReader = true;
